'use strict';

const jQuery = require('jquery');
const uniqid = require('uniq-id');
require('cropper');

const FormBuilder = require('./../../builder');
const Container = require('./../../../../core/container');
const Loader = require('./../../../../services/loader');
const Uploader = require('./../../../../bundles/content/service/uploader');
const Translator = require('./../../../../core/translator');

const FormatBytes = require('./../../../../bundles/content/service/formatBytes');
const UploadPlugin = require('./../../../../bundles/content/plugin/upload');

let ElementClass = require('./../../elementClass');

let tpl = require('./template/index.hbs');

FormBuilder.register('crop', function(config) {
  const imageDomain = Container.get('image-domain');

  let self = {};
  let bgImage = config.value.image || '';
  let ratio = config.ratio || (16 / 9);
  let onCrop = config.onCrop || jQuery.noop;
  let onBuilt = config.onBuilt || jQuery.noop;
  let onUpload = config.onUpload || jQuery.noop;
  let onDelete = config.onDelete || jQuery.noop;
  let onTabChange = config.onTabChange || jQuery.noop;
  let currentPositionY = config.value.positionY;
  let imageUrl = config.value.image || null;
  let $img;
  let $currentWrap;
  let maxSize = Container.get('$toolbar').data('maxSize');

  config.afterUpload = self.afterUpload;
  config.beforeUpload = self.beforeUpload;

  self = new ElementClass(config);

  self.beforeUpload = function() {
    Loader.start($currentWrap);
  };

  self.afterUpload = function(url) {
    imageUrl = url;

    $img.cropper('destroy');

    $img.attr('src', url + '?id=' + uniqid());

    $currentWrap.find('.remove').removeClass('d-none');

    Loader.stop($currentWrap);
  };

  self.render = function($wrap) {
    $currentWrap = $wrap;
    $wrap.append(tpl());
    $img = $wrap.find('img');
    let $labelNoImage = jQuery('<label class="cloud-label label-no-image">' + Translator.translate('no_image') + '</label>');

    if (config.tab) {
      config.form.on('tab:changed', (tab) => {
        if (tab === config.tab) {
          ratio = onTabChange() || ratio;

          $img.cropper('destroy');
          $img.attr('src', '');

          setTimeout(function() {
            $img.attr('src', imageUrl);
          }, 300);
        }
      });
    }

    const onUploadClick = function() {
      UploadPlugin.createMediaPopin({
        isImage: true,
        onChange: (file) => {
          return new Promise((resolve, reject) => {
            if ($wrap.find('.text-danger').length === 1) {
              $wrap.find('.text-danger').remove();
            }

            self.beforeUpload();

            if (file.size > maxSize) {
              $wrap.find('.image-wrapper').before('<p class="text-danger text-center font-weight-bold mt-2 ml-4 mb-2">' + Translator.translate('large_file_upload', {'size': FormatBytes.format(maxSize)}) + '</p>');
              Loader.stop($currentWrap);
              resolve();
            } else {
              Uploader.upload(file).done(function(data) {
                self.afterUpload(data.url);
                onUpload(data);

                if ($wrap.find('.label-no-image').length === 1) {
                  $wrap.find('.label-no-image').remove();
                }

                resolve();
              });
            }
          });
        },
        onMediaClick: (resource) => {
          return new Promise((resolve, reject) => {
            self.afterUpload(resource.url);
            onUpload(resource);

            resolve();
          });
        },
      });
    };

    const onDeleteUploadClick = function() {
      $img.attr('src', '');
      $img.cropper('destroy');

      $wrap.find('.remove').addClass('d-none');
      $wrap.find('.image-wrapper').append($labelNoImage);

      imageUrl = null;
      currentPositionY = '0%';

      onDelete($img);
    };

    $wrap.find('.upload').on('click', onUploadClick);
    $wrap.find('.remove').on('click', onDeleteUploadClick);

    $img.on('load', function() {
      $img.cropper({
        aspectRatio: ratio,
        checkCrossOrigin: false,
        crop: function(e) {
          let size = $img.cropper('getImageData');
          currentPositionY = e.y / (size.naturalHeight - e.height) * 100;

          onCrop.call(this, e, $img, currentPositionY);
        },
        autoCropArea: 0,
        strict: false,
        guides: false,
        highlight: false,
        dragCrop: false,
        cropBoxResizable: false,
        minContainerWidth: 360,
        minCropBoxWidth: 360,
        zoomable: false,
        built: function(...args) {
          onBuilt.call(this, $img, ...args);
        },
      });
    });

    if (imageDomain && bgImage.match(/^\/[^\/]/)) {
      bgImage = imageDomain + bgImage;
    }

    if (bgImage) {
      $img.attr('src', bgImage);
      imageUrl = bgImage;
    }

    if (!imageUrl) {
      $wrap.find('.remove').addClass('d-none');
      $wrap.find('.image-wrapper').append($labelNoImage);
    }
  };

  self.getData = function() {
    return {
      'image': imageUrl,
      'positionY': currentPositionY,
    };
  };

  return self;
});
